import { config } from '@config/config';

interface GTMEnvironment {
  gtm_auth: string;
  gtm_preview: string;
}

const DEFAULT_DOMAIN = config.gtm?.domain;

export const getDataLayerSnippet = ({
  dataLayer,
  dataLayerName = 'dataLayer',
}: {
  dataLayer?: Record<string, unknown>;
  dataLayerName?: string;
}): string =>
  `window.${dataLayerName} = window.${dataLayerName} || [];` +
  (dataLayer
    ? `window.${dataLayerName}.push(${JSON.stringify(dataLayer)})`
    : '');

export const getIframeSnippet = ({
  id,
  environment,
  customDomain = DEFAULT_DOMAIN,
}: {
  id: string;
  environment?: GTMEnvironment;
  customDomain?: string;
}): string => {
  let params = '';
  if (environment) {
    const { gtm_auth, gtm_preview } = environment;
    params = `&gtm_auth=${gtm_auth}&gtm_preview=${gtm_preview}&gtm_cookies_win=x`;
  }
  return `<iframe src="${customDomain}/ns.html?id=${id}${params}" height="0" width="0" style="display:none;visibility:hidden" id="tag-manager"></iframe>`;
};

export const getGTMScript = ({
  dataLayerName,
  id,
  environment,
  customDomain = DEFAULT_DOMAIN,
}: {
  dataLayerName: string;
  id: string;
  environment?: GTMEnvironment;
  customDomain?: string;
}): string => {
  let params = '';
  if (environment) {
    const { gtm_auth, gtm_preview } = environment;
    params = `+"&gtm_auth=${gtm_auth}&gtm_preview=${gtm_preview}&gtm_cookies_win=x"`;
  }
  return `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      '${customDomain}/gtm.js?id='+i+dl${params};f.parentNode.insertBefore(j,f);
    })(window,document,'script','${dataLayerName}','${id}');
  `;
};
